<div [formGroup]="form">

  <kendo-timepicker #timeElm
                    format="hh:mm a"
                    [ngClass]="{'input-validation-error': isTouched && isInValid }"
                    [id]="field.uniquename" [formControlName]="field.uniquename" placeholder="HH:MM AM/PM"
                    (focus)="onFocus(timeElm)"
                    (click) = "setDefaultTime()"
                    style="max-width: 200px;">
  </kendo-timepicker>

  <!--(blur)="onBlur(data,'starttime')"
  (valueChange)="onApptStartTimeChange(data,$event)"
  (click)="setApptStartTime(data)"-->
</div>
